import {useLocation, useParams} from "react-router-dom";
const ShowStaticImage = () =>{
    const location = useLocation();
    var result = /[^/]*$/.exec(location.pathname)[0];
    return(
        <img src={"http://localhost:3000/avatars/"+result+".png"}/>
    )
}

export default ShowStaticImage